import { render, staticRenderFns } from "./RencamSchedeMorteCaricamentoCsvDetailsList.vue?vue&type=template&id=05bbc1a8"
import script from "./RencamSchedeMorteCaricamentoCsvDetailsList.vue?vue&type=script&lang=js"
export * from "./RencamSchedeMorteCaricamentoCsvDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports